module.exports = __webpack_public_path__ + "img/terrain_park_large-185SQJn.svg";